import { render, staticRenderFns } from "./SpecialProductInfoImage.vue?vue&type=template&id=97eab2de&"
import script from "./SpecialProductInfoImage.vue?vue&type=script&lang=js&"
export * from "./SpecialProductInfoImage.vue?vue&type=script&lang=js&"
import style0 from "./SpecialProductInfoImage.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
